<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.80151 20.0141L6.55681 20.0141C5.13763 20.0141 3.98666 18.8631 3.98666 17.4439L3.98667 6.54984C3.98667 5.13066 5.13763 3.9797 6.55681 3.9797L9.80151 3.9797C10.2389 3.9797 10.5942 3.62541 10.5942 3.18805C10.5942 2.75069 10.2389 2.39539 9.80151 2.39539C9.80151 2.39539 8.18918 2.39539 6.55681 2.39539C4.2619 2.39539 2.40235 4.25493 2.40235 6.54984C2.40235 9.67845 2.40235 14.3153 2.40235 17.4439C2.40235 19.7388 4.2619 21.5984 6.55681 21.5984L9.80151 21.5984C10.2389 21.5984 10.5942 21.2441 10.5942 20.8067C10.5942 20.3694 10.2389 20.0141 9.80151 20.0141ZM21.5713 12.0654L21.5713 12.0644L21.5723 12.0634C21.5923 11.9964 21.6033 11.9263 21.6053 11.8533L21.6053 11.8503L21.6053 11.8493L21.6053 11.8483L21.6053 11.8473L21.6053 11.8443L21.6053 11.8413L21.6053 11.8393L21.6053 11.8342C21.6053 11.8332 21.6053 11.8312 21.6053 11.8292L21.6053 11.8273L21.6053 11.8252L21.6053 11.8242L21.6053 11.8212L21.6053 11.8202L21.6053 11.8192L21.6053 11.8162L21.6053 11.8152C21.6033 11.7422 21.5923 11.6721 21.5723 11.6051L21.5713 11.6041L21.5713 11.6031C21.5343 11.483 21.4692 11.3699 21.3732 11.2738L16.366 6.26661C16.0567 5.95735 15.5543 5.95735 15.245 6.26661C14.9358 6.57587 14.9358 7.07829 15.245 7.38655L18.9001 11.0426L8.39935 11.0426C7.96198 11.0426 7.60668 11.3969 7.60668 11.8342C7.60668 12.2716 7.96198 12.6269 8.39935 12.6269L18.9001 12.6269L15.245 16.282C14.9358 16.5912 14.9358 17.0936 15.245 17.4029C15.5543 17.7121 16.0567 17.7121 16.366 17.4029L21.3732 12.3947C21.4692 12.2996 21.5343 12.1865 21.5713 12.0654Z"
      fill="#141414"
    />
  </svg>
</template>

<script>
export default {
  name: 'Logout'
};
</script>

<style scoped>
svg path {
  fill: currentColor;
}
</style>
